export default {
  "table.operate": "操作",
  "table.operate.edit": "编辑",
  "table.operate.delete": "删除",
  "table.operate.add": "新增",
  "table.operate.confirmDelete": "确认删除？",
  "table.operate.confirmDeleteTips": "确认删除 {name} ？",
  "table.operate.failed": "操作失败",
  "table.operate.success": "操作成功",
  "table.operate.upload.imageLimit": "图片大小不能超过 1000MB!",


  //mall order list
  "table.order.id": "订单 ID",
  "table.order.productName": "商品名称",
  "table.order.price": "订单金额",
  "table.order.status": "订单状态",
  "table.order.userName": "用户名",
  "table.order.payment": "支付方式",
  "table.order.payment.1": "支付宝",
  "table.order.payment.2": "微信支付",
  "table.order.payment.3": "银联",
  "table.order.status.1": "未支付",
  "table.order.status.2": "已支付",
  "table.order.status.3": "已发货",
  "table.order.status.4": "已签收",
  "table.order.status.5": "已取消",
  "table.order.phone": "联系电话",
  "table.order.payTime": "支付时间",
  "table.order.craeteTime": "创建时间",
  //mall 

  //userManager list
  "table.userManager.userName": "用户名",
  "table.userManager.avatar": "头像",
  "table.userManager.sex": "性别",
  "table.userManager.phone": "联系电话",
  "table.userManager.email": "邮箱",
  "table.userManager.appointCount": "预约数",
  "table.userManager.followCount": "关注数",
  "table.userManager.fanCount": "粉丝数",
  "table.userManager.sex.1": "男",
  "table.userManager.sex.2": "女",
  "table.userManager.sex.3": "保密",
  "table.userManager.sex.0": "未知",
  "table.userManager.businessAuth": "商家认证",
  "table.userManager.businessAuth.0": "未认证",
  "table.userManager.businessAuth.1": "已认证",
  "table.userManager.inviteCode": "邀请码",
  "table.userManager.beInvitedCode": "受邀码",
  "table.userManager.edit": "编辑用户",

  //userManager appoint
  "table.userManager.appoint.id": "动态ID",
  "table.userManager.appoint.uid": "用户ID",
  "table.userManager.appoint.userName": "用户名",
  "table.userManager.appoint.content": "动态内容",
  "table.userManager.appoint.topicName": "话题名称",
  "table.userManager.appoint.zanNum": "点赞数",
  "table.userManager.appoint.evalNum": "评论数",
  "table.userManager.appoint.auditStatus": "审核状态",
  "table.userManager.appoint.auditStatus.0": "待审核",
  "table.userManager.appoint.auditStatus.1": "审核通过",
  "table.userManager.appoint.auditStatus.2": "审核拒绝",
  "table.userManager.appoint.createdTime": "创建时间",
  "table.userManager.appoint.audit": "审核",
  "table.userManager.appoint.auditModal.title": "审核动态",
  "table.userManager.appoint.auditModal.content": "动态内容",
  "table.userManager.appoint.auditModal.topic": "话题",
  "table.userManager.appoint.auditModal.media": "媒体文件",
  "table.userManager.appoint.auditModal.result": "审核结果",
  "table.userManager.appoint.auditModal.pass": "审核通过",
  "table.userManager.appoint.auditModal.reject": "审核拒绝",
  "table.operate.desc": "操作描述",
  "table.operate.desc.placeholder": "请输入操作描述",

  //permission log
  "table.permissionLog.id": "日志ID",
  "table.permissionLog.adminName": "管理员名称",
  "table.permissionLog.addModules": "新增权限",
  "table.permissionLog.delModules": "删除权限",
  "table.permissionLog.changedName": "操作人",
  "table.permissionLog.reason": "操作原因",
  "table.permissionLog.createdTime": "操作时间",

  //user auth
  "table.userAuth.id": "认证ID",
  "table.userAuth.uid": "用户ID",
  "table.userAuth.certType": "证件类型",
  "table.userAuth.realName": "真实姓名",
  "table.userAuth.certNo": "证件号码",
  "table.userAuth.status": "认证状态",
  "table.userAuth.status.1": "已认证",
  "table.userAuth.status.2": "认证失败",
  "table.userAuth.createdTime": "创建时间",
  "table.userAuth.updateTime": "更新时间",

  //role
  "table.role.name": "角色名称",
  "table.role.description": "角色描述",
  "table.role.permissions": "权限配置",
  "table.role.name.placeholder": "请输入角色名称",
  "table.role.description.placeholder": "请输入角色描述",

  //鉴定分类
  "table.identityCategory.id": "分类ID",
  "table.identityCategory.categoryName": "分类名称",
  "table.identityCategory.parentId": "上级分类",
  "table.identityCategory.sortOrder": "排序",
  "table.identityCategory.status": "状态",
  "table.identityCategory.status.0": "禁用",
  "table.identityCategory.status.1": "启用",
  "table.identityCategory.addChild": "添加子分类",
  "table.operation": "操作",

  //鉴定记录
  "table.identityHistory.createTime": "创建时间",
  "table.identityHistory.updateTime": "更新时间",
  "table.identityHistory.categoryId": "分类 ID",
  "table.identityHistory.name": "项目名称",
  "table.identityHistory.price": "鉴定价格",
  "table.identityHistory.status": "状态",
  "table.identityHistory.status.0": "待付款",
  "table.identityHistory.status.1": "鉴定中",
  "table.identityHistory.status.2": "已鉴定",
  "table.identityHistory.status.3": "已取消",
  "table.identityHistory.mailMethod": "邮寄方式",
  "table.identityHistory.mailMethod.1": "平台邮寄",
  "table.identityHistory.mailMethod.2": "自行邮寄",
  "table.identityHistory.identityMethod": "鉴定方式",
  "table.identityHistory.identityMethod.1": "线上鉴定",
  "table.identityHistory.identityMethod.2": "线下鉴定",
  "table.identityHistory.identityMethod.3": "预约鉴定",
  "table.identityHistory.images": "图像",
  "table.identityHistory.identifyResult": "鉴定结果评价",
  "table.identityHistory.sealImage": "印章图片",
  "table.identityHistory.change": "开始鉴定",
  "table.identityHistory.identify": "鉴定",
  "table.identityHistory.identify.title": "商品鉴定",
  "table.identityHistory.identify.itemInfo": "商品信息",
  "table.identityHistory.identify.itemName": "商品名称",
  "table.identityHistory.identify.identifyName": "鉴定师名称",
  "table.identityHistory.identify.identifyHeader": "鉴定师头像",
  "table.identityHistory.identify.appraisalItemNum": "鉴定项目数量",
  "table.identityHistory.identify.appraisalProcess": "鉴定流程",
  "table.identityHistory.identify.process.front": "产品正面",
  "table.identityHistory.identify.process.back": "产品背面",
  "table.identityHistory.identify.process.bottom": "产品底部",
  "table.identityHistory.identify.process.side": "产品侧面",
  "table.identityHistory.identify.process.add": "添加鉴定流程",
  "table.identityHistory.identify.process.name": "流程名称",
  "table.identityHistory.identify.process.nameRequired": "请输入流程名称",
  "table.identityHistory.identify.process.enable": "启用",
  "table.identityHistory.identify.process.required": "至少需要一个鉴定流程",
  "table.identityHistory.identify.submit": "提交鉴定",
  "table.identityHistory.identify.cancel": "取消",
  "table.identityHistory.identify.success": "鉴定提交成功",
  "table.identityHistory.identify.failed": "鉴定提交失败",
  "table.identityHistory.identify.required": "请输入鉴定师名称",
  "table.identityHistory.identify.itemNumRequired": "请输入鉴定项目数量",
  "table.identityHistory.identify.identifyResult": "鉴定结果评价",
  "table.identityHistory.identify.identifyResult.required": "请输入鉴定结果评价",
  "table.identityHistory.identify.identifyResult.placeholder": "请输入鉴定结果评价",
  "table.identityHistory.identify.sealImage": "印章图片",
  "table.identityHistory.identify.sealImage.required": "请上传印章图片",

  //address
  "table.address.id": "地址ID",
  "table.address.uid": "用户ID",
  "table.address.consignee": "收货人",
  "table.address.mobile": "联系电话",
  "table.address.province": "省份",
  "table.address.city": "城市",
  "table.address.district": "区县",
  "table.address.detailAddress": "详细地址",
  "table.address.isDefault": "默认地址",
  "table.address.isDefault.0": "否",
  "table.address.isDefault.1": "是",
  "table.address.createdTime": "创建时间",
  "table.address.updateTime": "更新时间",
  "table.address.fullAddress": "完整地址",

  //comment
  "table.comment.id": "动态ID",
  "table.comment.appointmentId": "预约ID",
  "table.comment.uid": "用户ID",
  "table.comment.userName": "用户名",
  "table.comment.content": "评论内容",
  "table.comment.zanNum": "点赞数",
  "table.comment.parentId": "父评论ID",
  "table.comment.rootId": "根评论ID",
  "table.comment.createdTime": "创建时间",
  "table.comment.detail": "查看详情",
  "table.comment.detailModal.title": "评论详情",
  "table.comment.detailModal.close": "关闭",
  "table.comment.list.title": "评论列表",
  "table.comment.fetch.error": "获取评论列表失败",

  //order review
  "table.order.review.title": "订单评价",
  "table.order.review.orderInfo": "订单信息",
  "table.order.review.orderId": "订单ID",
  "table.order.review.productName": "商品名称",
  "table.order.review.orderAmount": "订单金额",
  "table.order.review.rating": "评分",
  "table.order.review.rating.required": "请选择评分",
  "table.order.review.content": "评价内容",
  "table.order.review.content.required": "请输入评价内容",
  "table.order.review.content.placeholder": "请输入您的评价内容",
  "table.order.review.upload": "上传图片/视频",
  "table.order.review.upload.button": "上传文件",
  "table.order.review.upload.formats": "支持的图片格式：JPEG, JPG, PNG, GIF, WebP",
  "table.order.review.upload.videoFormats": "支持的视频格式：MP4, AVI, MOV, WMV, FLV, WebM",
  "table.order.review.upload.limits": "单个文件不超过10MB，最多上传9个文件",
  "table.order.review.upload.maxFiles": "最多只能上传9个文件",
  "table.order.review.upload.formatError": "不支持的文件格式",
  "table.order.review.upload.sizeError": "文件大小不能超过10MB",
  "table.order.review.upload.failed": "上传失败",
  "table.order.review.submit": "提交评价",
  "table.order.review.cancel": "取消",
  "table.order.review.success": "评价提交成功",
  "table.order.review.failed": "评价提交失败",
  "table.order.review.action": "评价",

  //product audit
  "table.product.audit.title": "商品审核",
  "table.product.audit.productInfo": "商品信息",
  "table.product.audit.productName": "商品名称",
  "table.product.audit.productDesc": "商品描述",
  "table.product.audit.productPrice": "商品价格",
  "table.product.audit.publisher": "发布用户",
  "table.product.audit.result": "审核结果",
  "table.product.audit.pass": "审核通过",
  "table.product.audit.reject": "审核拒绝",
  "table.product.audit.reason": "拒绝原因",
  "table.product.audit.reason.required": "请输入拒绝原因",
  "table.product.audit.reason.placeholder": "请输入审核拒绝的原因",
  "table.product.audit.submit": "提交审核",
  "table.product.audit.cancel": "取消",
  "table.product.audit.success": "审核提交成功",
  "table.product.audit.failed": "审核提交失败",
  "table.product.audit.action": "审核",
  "table.product.auditStatus": "审核状态",
  "table.product.auditStatus.0": "待审核",
  "table.product.auditStatus.1": "审核通过",
  "table.product.auditStatus.2": "审核拒绝",

  //order comment list
  "table.orderComment.title": "订单评价列表",
  "table.orderComment.id": "评价ID",
  "table.orderComment.orderId": "订单ID",
  "table.orderComment.userName": "用户名",
  "table.orderComment.rating": "评分",
  "table.orderComment.content": "评价内容",
  "table.orderComment.mediaData": "评价图片/视频",
  "table.orderComment.createdTime": "评价时间",
  "table.orderComment.detail": "查看详情",
  "table.orderComment.detailModal.title": "评价详情",
  "table.orderComment.detailModal.orderInfo": "订单信息",
  "table.orderComment.detailModal.userInfo": "用户信息",
  "table.orderComment.detailModal.rating": "评分",
  "table.orderComment.detailModal.content": "评价内容",
  "table.orderComment.detailModal.media": "评价媒体",
  "table.orderComment.detailModal.close": "关闭",
  "table.orderComment.detailModal.commentId": "评价ID",
  "table.orderComment.detailModal.orderId": "订单ID",
  "table.orderComment.detailModal.productId": "商品ID",
  "table.orderComment.detailModal.userName": "用户名",
  "table.orderComment.detailModal.userId": "用户ID",
  "table.orderComment.detailModal.userAvatar": "用户头像",
  "table.orderComment.detailModal.ratingScore": "分",
  "table.orderComment.detailModal.noContent": "暂无评价内容",
  "table.orderComment.detailModal.commentTime": "评价时间",
  "table.orderComment.detailModal.commentImage": "评价图片",
  "table.orderComment.detailModal.clickToPlay": "点击播放",
  "table.orderComment.detailModal.image": "图片",
  "table.orderComment.detailModal.video": "视频",

  "table.guide.id": "ID",
  "table.guide.pageName": "页面名称",
  "table.guide.image": "图片",
  "table.guide.sortOrder": "排序",
  "table.guide.createdTime": "创建时间",

  //withdraw record
  "table.withdraw.title": "提现记录列表",
  "table.withdraw.id": "提现ID",
  "table.withdraw.outBillNo": "外部订单号",
  "table.withdraw.uid": "用户ID",
  "table.withdraw.userName": "用户名",
  "table.withdraw.withdrawAmount": "提现金额",
  "table.withdraw.serviceFee": "服务费",
  "table.withdraw.withdrawType": "提现类型",
  "table.withdraw.withdrawType.1": "支付宝",
  "table.withdraw.withdrawType.2": "微信零钱",
  "table.withdraw.withdrawType.3": "银行卡",
  "table.withdraw.withdrawStatus": "提现状态",
  "table.withdraw.withdrawStatus.0": "审核中",
  "table.withdraw.withdrawStatus.1": "转账中",
  "table.withdraw.withdrawStatus.2": "转账成功",
  "table.withdraw.withdrawStatus.3": "转账失败",
  "table.withdraw.withdrawStatus.4": "取消转账",
  "table.withdraw.transferBillNo": "转账单号",
  "table.withdraw.remark": "备注",
  "table.withdraw.auditStatus": "审核状态",
  "table.withdraw.auditStatus.0": "待审核",
  "table.withdraw.auditStatus.1": "审核通过",
  "table.withdraw.auditStatus.2": "审核拒绝",
  "table.withdraw.adminName": "审核人",
  "table.withdraw.createdTime": "申请时间",
  "table.withdraw.updateTime": "更新时间",
  "table.withdraw.audit": "审核",
  "table.withdraw.audit.title": "审核提现申请",
  "table.withdraw.audit.userInfo": "用户信息",
  "table.withdraw.audit.withdrawInfo": "提现信息",
  "table.withdraw.audit.amount": "提现金额",
  "table.withdraw.audit.fee": "服务费",
  "table.withdraw.audit.actualAmount": "实际到账",
  "table.withdraw.audit.result": "审核结果",
  "table.withdraw.audit.pass": "审核通过",
  "table.withdraw.audit.reject": "审核拒绝",
  "table.withdraw.audit.reason": "拒绝原因",
  "table.withdraw.audit.reason.required": "请输入拒绝原因",
  "table.withdraw.audit.reason.placeholder": "请输入审核拒绝的原因",
  "table.withdraw.audit.submit": "提交审核",
  "table.withdraw.audit.cancel": "取消",
  "table.withdraw.audit.success": "审核提交成功",
  "table.withdraw.audit.failed": "审核提交失败",
}